export const SYSTEM_ADMINISTRATOR = "SystemAdministrator";
export const CUSTOMER_ADMINISTRATOR = "CustomerAdministrator";
export const WEBMAIL_SERVICE = "WebmailService";
